import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width, height} = useWindowDimensions();

  return {
    defaultContainerStyle: {
      width: width - 32,
      marginTop: Platform.OS === 'web' ? 0 : 15,
      paddingBottom: 150,
    },
    defaultItemContainerStyle: {
      paddingHorizontal: 16,
      paddingVertical: 16,
    },
    defaultTextStyle: {
      fontSize: 16,
      lineHeight: 24,
      color: colors.primaryTextColor,
      ...typography.interRegular,
    },
    defaultContentContainer: {
      shadowColor: colors.black,
      shadowOffset: {
        width: 2,
        height: 1,
      },
      shadowOpacity: 0.15,
      shadowRadius: 2.24,

      elevation: 3,
    },
    defaultFlatListStyle: {
      borderRadius: 10,
      backgroundColor: colors.white,
    },
    defaultItemSeparator: {
      height: 1,
      backgroundColor: colors.gallery,
    },
    backgroundColor: (isSelected: boolean) => ({
      backgroundColor: isSelected ? colors.dirtyWhite : 'transparent',
    }),
  };
};
